export const EXPERIENCE_ANALYTICS_TYPE = {
  google_analytics: "google_analytics",
  google_tag_manager: "google_tag_manager"
};
